/* tslint:disable */
/* eslint-disable */
/**
 * BusService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, RequiredError } from '../base';
// @ts-ignore
import { GetPastServicesAverageRequestDto } from '../model';
// @ts-ignore
import { GetServiceInputDto } from '../model';
// @ts-ignore
import { GetServicesRequest } from '../model';
// @ts-ignore
import { GetServicesResult } from '../model';
// @ts-ignore
import { GetServicesResultBus } from '../model';
// @ts-ignore
import { RaviResponse } from '../model';
/**
 * GetServicesApiApiCheckAvailableGet - axios parameter creator
 * 
 * @param {number} [from] 
 * @param {number} [to] 
 * @param {string} [date] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function GetServicesApiApiCheckAvailableGetAxiosParamCreator (from?: number, to?: number, date?: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/CheckAvailable`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (from !== undefined) {
        localVarQueryParameter['from'] = from;
    }

    if (to !== undefined) {
        localVarQueryParameter['to'] = to;
    }

    if (date !== undefined) {
        localVarQueryParameter['date'] = (date as any instanceof Date) ?
            (date as any).toISOString() :
            date;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * GetServicesApiApiGetBusServicesPost - axios parameter creator
 * 
 * @param {GetServiceInputDto} [getServiceInputDto] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function GetServicesApiApiGetBusServicesPostAxiosParamCreator (getServiceInputDto?: GetServiceInputDto, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/GetBusServices`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(getServiceInputDto, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * GetServicesApiApiGetServicesCuratedPost - axios parameter creator
 * 
 * @param {GetServicesRequest} [getServicesRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function GetServicesApiApiGetServicesCuratedPostAxiosParamCreator (getServicesRequest?: GetServicesRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/GetServices/Curated`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(getServicesRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * GetServicesApiApiGetServicesGet - axios parameter creator
 * 
 * @param {number} [from] 
 * @param {number} [to] 
 * @param {string} [date] 
 * @param {number} [count] 
 * @param {number} [pageNo] 
 * @param {number} [pageSize] 
 * @param {boolean} [includeClosed] 
 * @param {boolean} [update] 
 * @param {boolean} [loadFromDbOnUnavailability] 
 * @param {number} [providerId] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function GetServicesApiApiGetServicesGetAxiosParamCreator (from?: number, to?: number, date?: string, count?: number, pageNo?: number, pageSize?: number, includeClosed?: boolean, update?: boolean, loadFromDbOnUnavailability?: boolean, providerId?: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/GetServices`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (from !== undefined) {
        localVarQueryParameter['from'] = from;
    }

    if (to !== undefined) {
        localVarQueryParameter['to'] = to;
    }

    if (date !== undefined) {
        localVarQueryParameter['date'] = (date as any instanceof Date) ?
            (date as any).toISOString() :
            date;
    }

    if (count !== undefined) {
        localVarQueryParameter['count'] = count;
    }

    if (pageNo !== undefined) {
        localVarQueryParameter['pageNo'] = pageNo;
    }

    if (pageSize !== undefined) {
        localVarQueryParameter['pageSize'] = pageSize;
    }

    if (includeClosed !== undefined) {
        localVarQueryParameter['includeClosed'] = includeClosed;
    }

    if (update !== undefined) {
        localVarQueryParameter['update'] = update;
    }

    if (loadFromDbOnUnavailability !== undefined) {
        localVarQueryParameter['loadFromDbOnUnavailability'] = loadFromDbOnUnavailability;
    }

    if (providerId !== undefined) {
        localVarQueryParameter['providerId'] = providerId;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * GetServicesApiApiGetServicesGetPastServicesAveragePost - axios parameter creator
 * 
 * @param {GetPastServicesAverageRequestDto} [getPastServicesAverageRequestDto] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function GetServicesApiApiGetServicesGetPastServicesAveragePostAxiosParamCreator (getPastServicesAverageRequestDto?: GetPastServicesAverageRequestDto, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/GetServices/GetPastServicesAverage`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(getPastServicesAverageRequestDto, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * GetServicesApiApiGetServicesPost - axios parameter creator
 * 
 * @param {GetServicesRequest} [getServicesRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function GetServicesApiApiGetServicesPostAxiosParamCreator (getServicesRequest?: GetServicesRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/GetServices`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(getServicesRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * GetServicesApiApiGetServicesRaviGet - axios parameter creator
 * 
 * @param {string} [originCode] 
 * @param {string} [destCode] 
 * @param {string} [dateMove] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function GetServicesApiApiGetServicesRaviGetAxiosParamCreator (originCode?: string, destCode?: string, dateMove?: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/GetServices/Ravi`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (originCode !== undefined) {
        localVarQueryParameter['OriginCode'] = originCode;
    }

    if (destCode !== undefined) {
        localVarQueryParameter['DestCode'] = destCode;
    }

    if (dateMove !== undefined) {
        localVarQueryParameter['DateMove'] = dateMove;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * GetServicesApiApiGetTaxiServicesPost - axios parameter creator
 * 
 * @param {GetServiceInputDto} [getServiceInputDto] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function GetServicesApiApiGetTaxiServicesPostAxiosParamCreator (getServiceInputDto?: GetServiceInputDto, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/GetTaxiServices`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(getServiceInputDto, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}

/**
 * Request parameters for apiCheckAvailableGet operation in GetServicesApi.
 * @export
 * @interface GetServicesApiApiCheckAvailableGetRequest
 */
export interface GetServicesApiApiCheckAvailableGetRequest {
    /**
     * 
     * @type {number}
     * @memberof GetServicesApiApiCheckAvailableGet
     */
    readonly from?: number

    /**
     * 
     * @type {number}
     * @memberof GetServicesApiApiCheckAvailableGet
     */
    readonly to?: number

    /**
     * 
     * @type {string}
     * @memberof GetServicesApiApiCheckAvailableGet
     */
    readonly date?: string
}

/**
 * Request parameters for apiGetBusServicesPost operation in GetServicesApi.
 * @export
 * @interface GetServicesApiApiGetBusServicesPostRequest
 */
export interface GetServicesApiApiGetBusServicesPostRequest {
    /**
     * 
     * @type {GetServiceInputDto}
     * @memberof GetServicesApiApiGetBusServicesPost
     */
    readonly getServiceInputDto?: GetServiceInputDto
}

/**
 * Request parameters for apiGetServicesCuratedPost operation in GetServicesApi.
 * @export
 * @interface GetServicesApiApiGetServicesCuratedPostRequest
 */
export interface GetServicesApiApiGetServicesCuratedPostRequest {
    /**
     * 
     * @type {GetServicesRequest}
     * @memberof GetServicesApiApiGetServicesCuratedPost
     */
    readonly getServicesRequest?: GetServicesRequest
}

/**
 * Request parameters for apiGetServicesGet operation in GetServicesApi.
 * @export
 * @interface GetServicesApiApiGetServicesGetRequest
 */
export interface GetServicesApiApiGetServicesGetRequest {
    /**
     * 
     * @type {number}
     * @memberof GetServicesApiApiGetServicesGet
     */
    readonly from?: number

    /**
     * 
     * @type {number}
     * @memberof GetServicesApiApiGetServicesGet
     */
    readonly to?: number

    /**
     * 
     * @type {string}
     * @memberof GetServicesApiApiGetServicesGet
     */
    readonly date?: string

    /**
     * 
     * @type {number}
     * @memberof GetServicesApiApiGetServicesGet
     */
    readonly count?: number

    /**
     * 
     * @type {number}
     * @memberof GetServicesApiApiGetServicesGet
     */
    readonly pageNo?: number

    /**
     * 
     * @type {number}
     * @memberof GetServicesApiApiGetServicesGet
     */
    readonly pageSize?: number

    /**
     * 
     * @type {boolean}
     * @memberof GetServicesApiApiGetServicesGet
     */
    readonly includeClosed?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof GetServicesApiApiGetServicesGet
     */
    readonly update?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof GetServicesApiApiGetServicesGet
     */
    readonly loadFromDbOnUnavailability?: boolean

    /**
     * 
     * @type {number}
     * @memberof GetServicesApiApiGetServicesGet
     */
    readonly providerId?: number
}

/**
 * Request parameters for apiGetServicesGetPastServicesAveragePost operation in GetServicesApi.
 * @export
 * @interface GetServicesApiApiGetServicesGetPastServicesAveragePostRequest
 */
export interface GetServicesApiApiGetServicesGetPastServicesAveragePostRequest {
    /**
     * 
     * @type {GetPastServicesAverageRequestDto}
     * @memberof GetServicesApiApiGetServicesGetPastServicesAveragePost
     */
    readonly getPastServicesAverageRequestDto?: GetPastServicesAverageRequestDto
}

/**
 * Request parameters for apiGetServicesPost operation in GetServicesApi.
 * @export
 * @interface GetServicesApiApiGetServicesPostRequest
 */
export interface GetServicesApiApiGetServicesPostRequest {
    /**
     * 
     * @type {GetServicesRequest}
     * @memberof GetServicesApiApiGetServicesPost
     */
    readonly getServicesRequest?: GetServicesRequest
}

/**
 * Request parameters for apiGetServicesRaviGet operation in GetServicesApi.
 * @export
 * @interface GetServicesApiApiGetServicesRaviGetRequest
 */
export interface GetServicesApiApiGetServicesRaviGetRequest {
    /**
     * 
     * @type {string}
     * @memberof GetServicesApiApiGetServicesRaviGet
     */
    readonly originCode?: string

    /**
     * 
     * @type {string}
     * @memberof GetServicesApiApiGetServicesRaviGet
     */
    readonly destCode?: string

    /**
     * 
     * @type {string}
     * @memberof GetServicesApiApiGetServicesRaviGet
     */
    readonly dateMove?: string
}

/**
 * Request parameters for apiGetTaxiServicesPost operation in GetServicesApi.
 * @export
 * @interface GetServicesApiApiGetTaxiServicesPostRequest
 */
export interface GetServicesApiApiGetTaxiServicesPostRequest {
    /**
     * 
     * @type {GetServiceInputDto}
     * @memberof GetServicesApiApiGetTaxiServicesPost
     */
    readonly getServiceInputDto?: GetServiceInputDto
}

/**
* 
* @param {GetServicesApiApiCheckAvailableGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function GetServicesApiApiCheckAvailableGet(requestParameters: GetServicesApiApiCheckAvailableGetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await GetServicesApiApiCheckAvailableGetAxiosParamCreator(requestParameters.from, requestParameters.to, requestParameters.date, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {GetServicesApiApiGetBusServicesPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function GetServicesApiApiGetBusServicesPost(requestParameters: GetServicesApiApiGetBusServicesPostRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await GetServicesApiApiGetBusServicesPostAxiosParamCreator(requestParameters.getServiceInputDto, options, configuration);
    const request: () => AxiosPromise<GetServicesResult> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {GetServicesApiApiGetServicesCuratedPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function GetServicesApiApiGetServicesCuratedPost(requestParameters: GetServicesApiApiGetServicesCuratedPostRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await GetServicesApiApiGetServicesCuratedPostAxiosParamCreator(requestParameters.getServicesRequest, options, configuration);
    const request: () => AxiosPromise<GetServicesResult> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {GetServicesApiApiGetServicesGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function GetServicesApiApiGetServicesGet(requestParameters: GetServicesApiApiGetServicesGetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await GetServicesApiApiGetServicesGetAxiosParamCreator(requestParameters.from, requestParameters.to, requestParameters.date, requestParameters.count, requestParameters.pageNo, requestParameters.pageSize, requestParameters.includeClosed, requestParameters.update, requestParameters.loadFromDbOnUnavailability, requestParameters.providerId, options, configuration);
    const request: () => AxiosPromise<Array<GetServicesResultBus>> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {GetServicesApiApiGetServicesGetPastServicesAveragePostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function GetServicesApiApiGetServicesGetPastServicesAveragePost(requestParameters: GetServicesApiApiGetServicesGetPastServicesAveragePostRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await GetServicesApiApiGetServicesGetPastServicesAveragePostAxiosParamCreator(requestParameters.getPastServicesAverageRequestDto, options, configuration);
    const request: () => AxiosPromise<number> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {GetServicesApiApiGetServicesPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function GetServicesApiApiGetServicesPost(requestParameters: GetServicesApiApiGetServicesPostRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await GetServicesApiApiGetServicesPostAxiosParamCreator(requestParameters.getServicesRequest, options, configuration);
    const request: () => AxiosPromise<GetServicesResult> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {GetServicesApiApiGetServicesRaviGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function GetServicesApiApiGetServicesRaviGet(requestParameters: GetServicesApiApiGetServicesRaviGetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await GetServicesApiApiGetServicesRaviGetAxiosParamCreator(requestParameters.originCode, requestParameters.destCode, requestParameters.dateMove, options, configuration);
    const request: () => AxiosPromise<RaviResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {GetServicesApiApiGetTaxiServicesPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function GetServicesApiApiGetTaxiServicesPost(requestParameters: GetServicesApiApiGetTaxiServicesPostRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await GetServicesApiApiGetTaxiServicesPostAxiosParamCreator(requestParameters.getServiceInputDto, options, configuration);
    const request: () => AxiosPromise<GetServicesResult> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
